<template>
    <el-card class="main-card">
        <div slot="header" style="display: flex; align-items: center; justify-content: space-between">
            <span style="font-size: 18px; font-weight: bold">产品基准毛利</span>
            <div style="display: flex; align-items: center; gap: 8px">
                <el-select size="mini" v-model="searchModelId" placeholder="按产品型号筛选" filterable clearable
                    style="width: 220px" @change="handleSearch" @clear="handleSearch">
                    <el-option v-for="item in modelOptions" :key="item.id" :value="item.id" :label="item.name" />
                </el-select>
                <el-button size="mini" type="primary" icon="el-icon-plus" @click="openAddDialog">新增基准毛利</el-button>
            </div>
        </div>

        <el-table :data="tableData" border stripe v-loading="loading" style="width: 100%">
            <el-table-column type="index" label="序号" width="60" align="center" />
            <el-table-column label="关联产品型号" min-width="180">
                <template slot-scope="scope">
                    <div v-if="modelOf(scope.row)">
                        <div>{{ modelOf(scope.row).name }}</div>
                        <div style="color: #9ca3af; font-size: 12px">{{ modelOf(scope.row).code }}</div>
                    </div>
                    <span v-else>{{ scope.row.modelId || '--' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="基准毛利率" width="140" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.baseMarginRate !== null && scope.row.baseMarginRate !== undefined"
                        style="font-weight: 600; color: #1890ff">{{ scope.row.baseMarginRate }}%</span>
                    <span v-else>--</span>
                </template>
            </el-table-column>
            <el-table-column label="状态" width="90" align="center">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="mini">
                        {{ scope.row.status === 1 ? '启用' : '停用' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" width="170" align="center">
                <template slot-scope="scope">
                    {{ scope.row.createdTime || '--' }}
                </template>
            </el-table-column>
            <el-table-column label="更新时间" width="170" align="center">
                <template slot-scope="scope">
                    {{ scope.row.updatedTime || '--' }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="130" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" type="text" @click="openEditDialog(scope.row)">编辑</el-button>
                    <el-button size="mini" type="text" style="color: #f56c6c"
                        @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total" background class="pagination" />
        </div>

        <!-- 新增/编辑基准毛利弹窗 -->
        <el-dialog :title="editId ? '编辑基准毛利' : '新增基准毛利'" :visible.sync="addVisible" width="520px"
            :close-on-click-modal="false" @closed="resetAddForm">
            <el-form ref="addFormRef" :model="addForm" :rules="addRules" label-width="110px">
                <el-form-item label="关联产品型号" prop="modelId">
                    <el-select v-model="addForm.modelId" placeholder="请选择产品型号" filterable style="width: 100%">
                        <el-option v-for="item in modelOptions" :key="item.id" :value="item.id" :label="item.name">
                            <div style="display: flex; align-items: center; justify-content: space-between">
                                <span>{{ item.name }}</span>
                                <span style="color: #9ca3af; font-size: 12px">{{ item.code }}</span>
                            </div>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="基准毛利率(%)" prop="baseMarginRate">
                    <el-input-number v-model="addForm.baseMarginRate" :min="0" :max="100" :precision="2"
                        controls-position="right" style="width: 200px" />
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-switch v-model="addForm.status" :active-value="1" :inactive-value="0"
                        active-text="启用" inactive-text="停用" />
                </el-form-item>
            </el-form>
            <div slot="footer" style="display: flex; justify-content: flex-end; gap: 6px">
                <el-button @click="addVisible = false">取消</el-button>
                <el-button type="primary" :loading="addLoading" @click="handleSaveSubmit">保存</el-button>
            </div>
        </el-dialog>
    </el-card>
</template>

<script>
import {
    productBaseMarginRateList,
    productBaseMarginRateAdd,
    productBaseMarginRateUpdate,
    productBaseMarginRateDelete,
    productModelList
} from '@/api/quote'

export default {
    name: 'ProductBaseMarginRate',
    data() {
        return {
            searchModelId: '',
            loading: false,
            tableData: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            modelOptions: [],
            modelMap: {},
            addVisible: false,
            addLoading: false,
            editId: null,
            addForm: {
                modelId: null,
                baseMarginRate: 30,
                status: 1,
            },
            addRules: {
                modelId: [{ required: true, message: '请选择产品型号', trigger: 'change' }],
                baseMarginRate: [{ required: true, message: '请输入基准毛利率', trigger: 'blur' }],
            },
        }
    },
    mounted() {
        this.fetchList();
        this.fetchModelOptions();
    },
    methods: {
        // 取行关联的产品型号：优先接口回填的 productModel，否则查前端字典
        modelOf(row) {
            return row.productModel || this.modelMap[row.modelId] || null
        },

        // 获取基准毛利列表（分页）
        async fetchList() {
            this.loading = true;
            try {
                const params = {
                    current: this.currentPage,
                    size: this.pageSize,
                    filter: [],
                    sorted: [],
                }
                if (this.searchModelId) {
                    params.filter.push({
                        name: 'modelId',
                        type: 'EQ',
                        value: this.searchModelId
                    })
                }

                const res = await productBaseMarginRateList(params)
                if (res && res.code === '0000') {
                    this.tableData = res.result.records || [];
                    this.total = res.result.total || 0;
                } else {
                    this.tableData = [];
                    this.total = 0;
                    this.$message.error((res && res.message) || '获取基准毛利列表失败')
                }
            } catch (error) {
                console.error('获取产品基准毛利列表失败：', error)
                this.tableData = [];
                this.total = 0;
            } finally {
                this.loading = false;
            }
        },

        // 获取产品型号下拉选项（同时建字典用于表格型号名称显示）
        async fetchModelOptions() {
            if (this.modelOptions.length) return;
            try {
                const param = {
                    filter: [],
                    sorted: [],
                    current: 0,
                    size: 100,
                }
                const res = await productModelList(param)
                if (res && res.code === '0000') {
                    const records = res.result.records || []
                    this.modelOptions = records
                    const map = {}
                    records.forEach(item => {
                        map[item.id] = item
                    })
                    this.modelMap = map
                }
            } catch (error) {
                console.error('获取产品型号选项失败：', error)
            }
        },

        openAddDialog() {
            this.editId = null;
            this.addForm = {
                modelId: null,
                baseMarginRate: 30,
                status: 1,
            };
            this.addVisible = true;
            this.fetchModelOptions();
        },

        openEditDialog(row) {
            this.editId = row.id;
            this.addForm = {
                modelId: row.modelId || null,
                baseMarginRate: row.baseMarginRate !== undefined && row.baseMarginRate !== null ? row.baseMarginRate : null,
                status: row.status !== undefined && row.status !== null ? row.status : 1,
            };
            this.addVisible = true;
            this.fetchModelOptions();
        },

        resetAddForm() {
            this.editId = null;
            this.addForm = {
                modelId: null,
                baseMarginRate: 30,
                status: 1,
            };
            this.$refs.addFormRef && this.$refs.addFormRef.clearValidate();
        },

        // 提交保存（新增/编辑）
        handleSaveSubmit() {
            this.$refs.addFormRef.validate(async (valid) => {
                if (!valid) return;
                this.addLoading = true;
                try {
                    const param = {
                        modelId: this.addForm.modelId,
                        baseMarginRate: this.addForm.baseMarginRate,
                        status: this.addForm.status,
                    }
                    const res = this.editId
                        ? await productBaseMarginRateUpdate({ id: this.editId, ...param })
                        : await productBaseMarginRateAdd(param)
                    if (res && res.code === '0000') {
                        this.$message.success(this.editId ? '更新成功' : '新增成功')
                        this.addVisible = false;
                        this.fetchList();
                    } else {
                        this.$message.error((res && res.message) || (this.editId ? '更新失败' : '新增失败'))
                    }
                } catch (error) {
                    console.error('保存产品基准毛利失败：', error)
                } finally {
                    this.addLoading = false;
                }
            });
        },

        // 删除基准毛利
        handleDelete(row) {
            const model = this.modelOf(row)
            const name = (model && model.name) || `ID ${row.id}`
            this.$confirm(`此操作将永久删除【${name}】的基准毛利配置, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const res = await productBaseMarginRateDelete(row.id)
                    if (res && res.code === '0000') {
                        this.$message.success('删除成功')
                        if (this.tableData.length === 1 && this.currentPage > 1) {
                            this.currentPage -= 1;
                        }
                        this.fetchList();
                    } else {
                        this.$message.error((res && res.message) || '删除失败')
                    }
                } catch (error) {
                    console.error('删除产品基准毛利失败：', error)
                }
            }).catch(() => {});
        },

        handleSearch() {
            this.currentPage = 1;
            this.fetchList();
        },

        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.fetchList();
        },

        handleCurrentChange(val) {
            this.currentPage = val;
            this.fetchList();
        },
    }
}
</script>

<style scoped>
.main-card {
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: none;
}

.pagination-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #1890ff;
}
</style>